import {
	isConsentCategoryAllowed,
	isHeatmapCollectionAllowed,
	normalizeHeatmapTrackingConfig,
} from "@multi-tenant-cms/seo-runtime";
import type {
	CookieConsentCategorySelection,
	CookieConsentConfig,
	HeatmapEntryOverride,
	HeatmapTrackingConfig,
} from "@multi-tenant-cms/types";

export const HEATMAP_BOOTSTRAP_EVENT = "cms:heatmap:bootstrap";
export const HEATMAP_PAGE_CONTEXT_KEY = "__CMS_HEATMAP_PAGE__";

export type TenantHeatmapConfig = HeatmapTrackingConfig;

export type HeatmapPageWindowContext = {
	entry_id: string | null;
	override: HeatmapEntryOverride;
};

function asObject(value: unknown): Record<string, unknown> {
	return typeof value === "object" && value !== null && !Array.isArray(value)
		? (value as Record<string, unknown>)
		: {};
}

function asBoolean(value: unknown, fallback: boolean): boolean {
	return typeof value === "boolean" ? value : fallback;
}

export function normalizeHeatmapConfig(raw: unknown): TenantHeatmapConfig {
	const object = asObject(raw);
	return normalizeHeatmapTrackingConfig({
		...object,
		enabled: asBoolean(object.enabled, false),
	});
}

/** Site master switch + consent. Page scope is checked again on each click. */
export function isHeatmapConsentAllowed(
	config: TenantHeatmapConfig,
	consentConfig: CookieConsentConfig,
	selection: CookieConsentCategorySelection
): boolean {
	if (!config.enabled) {
		return false;
	}
	if (!config.require_cookie_consent) {
		return true;
	}
	return isConsentCategoryAllowed(
		consentConfig,
		selection,
		config.consent_category
	);
}

export function isHeatmapBootstrapAllowed(
	config: TenantHeatmapConfig,
	consentConfig: CookieConsentConfig,
	selection: CookieConsentCategorySelection,
	entryOverride?: HeatmapEntryOverride | null
): boolean {
	if (
		!isHeatmapCollectionAllowed({
			config,
			entry_override: entryOverride,
		})
	) {
		return false;
	}
	return isHeatmapConsentAllowed(config, consentConfig, selection);
}
